/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import { Button, Modal, CloseButton } from "react-bootstrap";
import "./WnbModalAlert.css";

const WnbModalSuccess = (props) => {
  let showAlert = props.showAlert;
  const onClickModalOk = props.handleOk;
  const onClickModalNew = props.handleNew;
  const onClickModalShowList = props.handleShowList;
  const title = props.title;
  const message = props.message;
  const createLabel = props.createLabel || "Create New";
  const showListLabel = props.showListLabel || "Show List";
  const successType = props.successType || "";

  return (
    <Modal
      show={showAlert}
      onHide={onClickModalOk}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title style={{color: "green"}}>{title}</Modal.Title>
        <CloseButton aria-label="Close" onClick={onClickModalOk}/>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClickModalNew}>
          {createLabel}
        </Button>
        { successType !== "TAG" ?
            <Button variant="secondary" onClick={onClickModalShowList}>
              {showListLabel}
            </Button>
        :
        null
        }

      </Modal.Footer>
    </Modal>
  );
};

export default WnbModalSuccess;